const deepCopy = (object) => JSON.parse(JSON.stringify(object));

/**
 * این متد برای کپی گرفتن از آرایه ای از آبجکت ها است که `دیتای حساس` مانند فایل و ... دارند.
 * @param arrayOfObjects - آرایه ای از آبجکت ها
 * @returns
 */
// @category Object, `true`, @example
const deepCopyArrayOfObjects = (arr: Array) => arr.map((obj) => ({ ...obj }));
// deepCopySensitiveData

export { deepCopy, deepCopyArrayOfObjects };
